import React from 'react';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import clsx from 'clsx';

interface Props {
  xs?: any;
  sm?: any;
  md?: any;
  lg?: any;
  item?: any;
  style?: any;
  className?: any;
  alignItems?: any;
  justify?: any;
  container?: any;
  onClick?: any;
  noPadding?: boolean;
  fullWidth?: any;
  verticalBorder?: any;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    fullWidth: {
      width: '100%',
    },
    noPadding: {
      padding: 0,
    },
    verticalBorder: {
      position: 'relative',
      '&::after': {
        content: "''",
        height: '95%',
        width: 2,
        position: 'absolute',
        right: 0,
        top: 20,
        backgroundColor: '#CCCCCC',
      },
    },
    hideBorder: {
      [theme.breakpoints.down('sm')]: {
        '&::after': {
          display: 'none',
        },
      },
    },
  }),
);

const ContainerItem: React.FC<Props> = ({
  xs,
  sm,
  md,
  lg,
  item,
  fullWidth,
  children,
  verticalBorder,
  noPadding,
  className,
  style,
  alignItems,
  justify,
  container,
  onClick,
}) => {
  const classes = useStyles();
  return (
    <Grid
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      item={item}
      className={clsx({
        [classes.fullWidth]: fullWidth,
        [classes.verticalBorder]: verticalBorder,
        [classes.hideBorder]: true,
        [classes.noPadding]: noPadding,
        [className]: className,
      })}
      style={style}
      alignItems={alignItems}
      justify={justify}
      container={container}
      onClick={onClick}
    >
      {children}
    </Grid>
  );
};

ContainerItem.defaultProps = {
  item: true,
  verticalBorder: false,
};

export default ContainerItem;
